import {
  type Page,
  type ConnectedPage,
  type Project,
} from 'components/framework/models';

/* eslint-disable no-unused-vars */
export enum CreateViews {
  MyWork = 'mywork',
  Notifications = 'notifications',
  Todos = 'todos',
  Tasks = 'tasks',
  Records = 'all_work',
  Initiatives = 'initiatives',
  Releases = 'releases',
  Features = 'features',
  Ideas = 'ideas',
  Document = 'document',
  Documents = 'documents',
  Recents = 'recents',
  Tags = 'tags',
  Shared = 'shared',
  Settings = 'settings',
  Calendar = 'calendar',
  Meetings = 'meetings',
}

export function createViewToPath(view: CreateViews) {
  switch (view) {
    case CreateViews.Recents:
      return 'documents/recents';
    case CreateViews.Shared:
      return 'documents/shared';
  }

  return view;
}

type HistoryEntry = {
  view?: CreateViews;
  page?: Page | ConnectedPage;
  project?: Project;
};

// A class to keep track of the history of pages/views visited.
class PageHistory {
  backStack: HistoryEntry[] = [];
  forwardStack: HistoryEntry[] = [];
  currentEntry: HistoryEntry = null;

  visitPage({ page, view, project }) {
    // Don't store null pages, don't store shared pages (we store the ConnectedPage object instead)
    if (view === 'document' && (!page || page.isShared)) {
      return;
    }
    if (this.currentEntry) {
      const { page: currentPage, view: currentView } = this.currentEntry;
      if (currentPage?.id !== page?.id || currentView !== view) {
        this.backStack.push(this.currentEntry);
      }
    }

    this.currentEntry = { view, page, project };
    this.forwardStack = [];
  }

  goBack() {
    if (this.currentEntry) {
      this.forwardStack.push(this.currentEntry);
    }

    this.currentEntry = this.backStack.pop();

    return this.currentEntry;
  }

  goForward() {
    if (this.currentEntry) {
      this.backStack.push(this.currentEntry);
    }

    this.currentEntry = this.forwardStack.pop();

    return this.currentEntry;
  }

  hasBack() {
    return this.backStack.length > 0;
  }

  hasForward() {
    return this.forwardStack.length > 0;
  }
}

export default PageHistory;
